import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import PreviewEditor from '../editor/PreviewEditor';

function Preview() {
    return (
        <Box width="100%" display="flex" flexDirection="column" justifyContent="space-between" >
            <Box p={1}  width="100%">
                <Typography variant="h5">Level 1 practice programs for module1</Typography>
            </Box>
            <Box width="100%" display="flex" justifyContent="space-evenly" flex={1} border="1px solid #ccc">
                <Box width="95%" display="flex" flexDirection="column" justifyContent="space-evenly" alignItems="center" >
                    <PreviewEditor />
                   
                </Box>
                <Box width="5%" display="flex" justifyContent="center" alignItems="flex-end" borderLeft="1px solid #ccc">
                    <IconButton color="primary" size="large" >
                        <AddIcon />
                    </IconButton>
                </Box>
            </Box>
        </Box>
    );
}

export default Preview;
